import React from 'react';
import { Logo } from './UI';

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--dark-10)', padding: '20px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--white)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Logo size="sm" />
        <span style={{ fontSize: 13, color: 'var(--dark-40)' }}>· Learning Hub</span>
      </div>
      <span style={{ fontSize: 12, color: 'var(--dark-40)', fontFamily: 'var(--font-heading)' }}>Algorhythmlab Pty Ltd · © 2026</span>
    </footer>
  );
}
